// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QzvJ","colMin":"styles_colMin__fqUHn"};